import React from "react";
import moment from 'moment';
import styles from "./InfoSection.module.css";
import {
  selectSelectedAsOfDate,
  selectSelectedAsOfDateStart,
} from "state/selections/selectors";
import SelectionState from "state/selections/SelectionState";
import { useSelector } from "react-redux";

const InfoSection = () => {
  const asOfDateStart = useSelector(
    selectSelectedAsOfDateStart(SelectionState.COMMITTED)
  );
  const asOfDate = useSelector(
    selectSelectedAsOfDate(SelectionState.COMMITTED)
  );
  const asOfDateStartMoment = asOfDateStart ? moment(asOfDateStart) : asOfDateStart
  const asOfDateMoment = asOfDate ? moment(asOfDate) : asOfDate
  return (
    <div className={styles.root}>
      <div className={styles.label}>Start Date:</div>
      <div className={styles.value}>{asOfDateStartMoment?.format('L')}</div>
      <div className={styles.label}>End Date:</div>
      <div className={styles.value}>{asOfDateMoment?.format('L')}</div>
    </div>
  );
};
export default InfoSection;
